import React from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import RentalAgreements from './RentalAgreements'

function RentalAgreementsIndex() {
  return (
    <div>
      <Navbar />
      <RentalAgreements />
      <Footer />
      
    </div>
  )
}

export default RentalAgreementsIndex
